import axios from "axios";
import { useFormik } from "formik";
import React, { useContext, useMemo } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { EndPoints } from "../../api";
import { SelectIcon, SelectedIcon } from "../../assets";
import { Button, Input, InputSelect } from "../../components";
import { config } from "../../config";
import {
  dialog,
  sponsorWrap,
  sponsorOption,
  numberLabel,
  numberDisplayArea,
  numbersDrop,
} from "./sponsor.module.css";
// import styles from "./sponsor.module.css";
import { sponsorValidator } from "./sponsorValidator";
import { AlertContext } from "../../context/context";

export const SponsorATalent = () => {
  const closeIcon = (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.5 18L18.5 30M18.5 18L30.5 30"
        stroke="#F53131"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="1" y="0.5" width="47" height="47" rx="23.5" stroke="#F53131" />
    </svg>
  );
  const [type, setType] = useState("");
  const [numberOfTalent, setNumberOfTalent] = useState(0);
  const [internType, setInternType] = useState("");
  const [loading, setLoading] = useState(false);

  const { setAlertState } = useContext(AlertContext);

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const waitHandler = async (waitArg) => {
    const { seconds, completed } = waitArg;
    if (!completed) {
      await sleep(seconds);
      return waitHandler(waitArg);
    }
    return () => true;
  };

  const handleSubmit = async (values) => {
    try {
      let dataToSubmit = {};
      if (type === "application-fee" && numberOfTalent === 0) {
        toast.error("Number of talent is required");
        return;
      } else if (type === "program-fee") {
        dataToSubmit = {
          ...values,
          payment_type: type,
          intern_type: internType,
          amount: Number(values.amount),
          total_talents: 1,
        };
      } else if (type === "free-will") {
        dataToSubmit = {
          ...values,
          payment_type: type,
          total_talents: 1,
        };
      } else {
        dataToSubmit = {
          ...values,
          total_talents: numberOfTalent,
          payment_type: type,
          amount: 50000 * numberOfTalent,
        };
      }

      setLoading(true);
      const result = await axios.post(EndPoints.sponsor, {
        ...dataToSubmit,
      });
      if (result.data.success) {
        // const { authorization_url } = result.data?.data ?? "";
        const { paymentUrl } = result.data?.data ?? "";
        setLoading(false);

        window.$("#sponsorTalentModal").modal("hide");
        window.location.href = paymentUrl;
        sessionStorage.setItem(
          "paySuccess",
          JSON.stringify({
            show: true,
            labelText:
              "Thanks, your payment was successful. Check email for instructions",
            failure: false,
            status: "Success",
            type: "Application payment",
          })
        );
      }
    } catch (error) {
      if (error) {
        setLoading(false);
        setAlertState({
          show: true,
          labelText: error?.response?.data?.message ?? "Something went wrong",
          failure: true,
          status: "Failure",
          type: "Sponsor Talent",
        });
      }
    }
  };

  const formik = useFormik({
    initialValues: {},
    validationSchema: sponsorValidator,
    onSubmit: (values) => handleSubmit(values),
  });

  return (
    <div
      className="modal fade"
      id="sponsorTalentModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        className={`modal-dialog modal-dialog-centered ${dialog}`}
        role="document"
      >
        <form className="modal-content" onSubmit={formik.handleSubmit}>
          <div className="modal-header border-0">
            <section>
              <h5 className="modal-title">Sponsor a Talent</h5>
              <p>
                You can contribute to the production of the next tech stars by
                sponsoring a talent!
              </p>
            </section>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              {closeIcon}
            </button>
          </div>
          <div className="modal-body">
            <section className="row mb-4">
              <div className="col-sm-4">
                <SponsorOption
                  name="Application fee"
                  desc="Program application fee"
                  id="application-fee"
                  selected={type}
                  setSelected={setType}
                />
              </div>
              <div className={`col-sm-4 ${sponsorWrap}`}>
                <SponsorOption
                  name="Program fee"
                  desc="Internship stipend"
                  id="program-fee"
                  selected={type}
                  setSelected={setType}
                />
              </div>
              <div className="col-sm-4">
                <SponsorOption
                  name="Free will"
                  desc="Decide an amount"
                  id="free-will"
                  selected={type}
                  setSelected={setType}
                />
              </div>
            </section>

            <section className="row pt-3">
              <div className="col-sm-6 mb-4">
                <Input
                  label="First name"
                  id="firstname"
                  placeholder="Enter first name"
                  disabled={type === ""}
                  name="firstname"
                  onChange={formik.handleChange}
                  error={formik.errors.firstname}
                  errorText={formik.errors.firstname}
                  value={formik.values.firstname}
                />
              </div>
              <div className="col-sm-6 mb-4">
                <Input
                  label="Last name"
                  placeholder="Enter last name"
                  disabled={type === ""}
                  name="lastname"
                  onChange={formik.handleChange}
                  error={formik.errors.lastname}
                  errorText={formik.errors.lastname}
                  value={formik.values.lastname}
                />
              </div>
              <div className="col-sm-6 mb-4">
                <Input
                  label="Email address"
                  placeholder="Enter email address"
                  disabled={type === ""}
                  name="email"
                  onChange={formik.handleChange}
                  error={formik.errors.email}
                  errorText={formik.errors.email}
                  value={formik.values.email}
                />
              </div>

              <div className="col-sm-6 mb-4">
                {type === "application-fee" ? (
                  <NumberOfSponsorDrop onChange={(e) => setNumberOfTalent(e)} />
                ) : type === "free-will" ? (
                  <Input
                    label="How much would you like to donate?"
                    placeholder="Enter amount"
                    type="number"
                    name="amount"
                    onChange={formik.handleChange}
                    error={formik.errors.amount}
                    errorText={
                      formik.errors.amount ? "This field is required" : ""
                    }
                    value={formik.values.amount}
                  />
                ) : type === "program-fee" ? (
                  <InputSelect
                    label="Internship type"
                    placeholder="Choose the Internship type"
                    options={[
                      { value: 1625000, name: "Physical Intern - ₦1,625,000" },
                      { value: 1210000, name: "Virtual Intern - ₦1,210,000" },
                    ]}
                    name="amount"
                    onChange={(e) => {
                      formik.handleChange(e);
                      setInternType(
                        e.target.value > 1220000 ? "physical" : "virtual"
                      );
                    }}
                    error={formik.errors.amount}
                    errorText={
                      formik.errors.amount ? "This field is required" : ""
                    }
                    value={formik.values.amount}
                    icon={<SelectIcon />}
                  />
                ) : (
                  <></>
                )}
              </div>
            </section>
          </div>
          <div className="modal-footer">
            <Button
              buttonName={loading ? "Processing..." : "Sponsor"}
              main="fill"
              disabled={type === "" || loading}
              type="submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

const SponsorOption = ({
  name = "",
  desc = "",
  id = "",
  selected = "",
  setSelected = () => {},
}) => {
  const handleChange = (e) => {
    setSelected(id);
  };
  return (
    <div
      className={sponsorOption}
      style={{
        backgroundColor: selected === id ? "#FAD4BE" : "",
        borderColor: selected === id ? "#FAD4BE" : "",
      }}
    >
      <span>
        <input
          type="radio"
          name="sponsorship"
          id={id}
          onChange={handleChange}
        />
        <span>
          <div></div>
        </span>
      </span>
      <label htmlFor={id}>
        <h5 className="mb-0">{name}</h5>
        <p className="mb-0">{desc}</p>
      </label>
    </div>
  );
};

const NumberOfSponsorDrop = ({ onChange = () => {} }) => {
  const [selected, setSelected] = useState("");

  const handleChange = (e) => {
    onChange(e);
  };

  const data = useMemo(
    () => [
      { name: "1 Talent - ₦50000", value: 1 },
      { name: "2 Talents - ₦100000", value: 2 },
      { name: "3 Talents - ₦150000", value: 3 },
      { name: "4 Talents - ₦200000", value: 4 },
      { name: "5 Talents - ₦250000", value: 5 },
    ],
    []
  );
  const getValueForDisplay = () => {
    return data.filter((d) => d.value === selected)[0]?.name ?? selected;
  };

  return (
    <>
      <label className={numberLabel} htmlFor="">
        How many talents would you like to sponsor?
      </label>
      <div className="btn-group w-100">
        <button
          className={numberDisplayArea}
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          style={{ color: !selected ? "#8D96B4" : "" }}
        >
          {!selected ? "Select how many talents" : getValueForDisplay()}
          <SelectIcon />
        </button>
        <div className={`dropdown-menu ${numbersDrop}`}>
          {data.map((item, i) => {
            return (
              <button
                className="dropdown-item"
                type="button"
                key={`select-num-${i}`}
                onClick={() => {
                  setSelected(item.value);
                  handleChange(item.value);
                }}
              >
                {item.name}
                {selected === item.value && <SelectedIcon fill="transparent" />}
              </button>
            );
          })}
          <section>
            <Input
              placeholder="Enter Number"
              type="number"
              onChange={(e) => {
                setSelected(
                  `${Number(e.target.value)} Talents - ₦${Number(
                    e.target.value * 40000
                  )}`
                );
                handleChange(e.target.value);
              }}
            />
          </section>
        </div>
      </div>
    </>
  );
};
